var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { offerList as api } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import { useOfferListColumns } from '../../hooks/useColumns';
import { UploadIcon } from '../atoms/Icons';
import MaterialTable from '../MaterialTable';
import { useNotify } from '../../hooks/notificationHook';
import { decamelize } from '../../utils/camelize';
import useFetch from '../../hooks/useFetch';
import qs from 'qs';
import PageLayout from '../atoms/PageLayout';
import { Box } from '@mui/material';
import DownloadButton from '../molecules/DownloadButton';
import Button from '../atoms/BaseButton';
var AdminOfferListsPage = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var notify = useNotify();
    var _a = React.useState([]), offerLists = _a[0], setOfferLists = _a[1];
    var destroy = useRequest(api.destroy);
    var OfferListColumns = useOfferListColumns('admin');
    var query = qs.parse(location.search.slice(1));
    var defaultFilter = React.useCallback(function (field) {
        var filters = query.filters || {};
        return filters[field];
    }, [query]);
    var columns = React.useMemo(function () { return [
        OfferListColumns.producerCountry,
        __assign(__assign({}, OfferListColumns.producerName), { field: 'producer', defaultFilter: defaultFilter('producer'), filtering: true }),
        __assign(__assign({}, OfferListColumns.name), { defaultFilter: defaultFilter('name') }),
        __assign(__assign({}, OfferListColumns.paymentTerm), { defaultFilter: defaultFilter('paymentTerm') }),
        __assign(__assign({}, OfferListColumns.officeNames), { defaultFilter: defaultFilter('officeNames') }),
        OfferListColumns.officeDetailsSampleOrderStartedAt,
        __assign(__assign({}, OfferListColumns.orderStartedAt), { filtering: false }),
        __assign(__assign({}, OfferListColumns.expiredAt), { filtering: false }),
        __assign(__assign({}, OfferListColumns.status), { defaultFilter: defaultFilter('status') }),
        OfferListColumns.contributeToOkagesamaNoMoris,
        OfferListColumns.csvDownloadAction,
        OfferListColumns.orderAction,
        OfferListColumns.forumAction,
    ]; }, [OfferListColumns, defaultFilter]);
    var handleDelete = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, destroy(data.id)];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    nextData = offerLists.filter(function (offerList) { return offerList.id !== data.id; });
                    setOfferLists(nextData);
                    notify('success', [t('messages.deleteSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, destroy, offerLists, notify]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'producer':
                    q.producer_firstname_or_producer_lastname_cont = filter.value;
                    break;
                case 'status':
                    q.with_status = filter.value;
                    break;
                case 'officeNames':
                    q.office_details_office_id_in = filter.value;
                    break;
                case 'paymentTerm':
                    q.with_payment_term = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var fetchOfferLists = useFetch({
        buildFilterParams: buildFilterParams,
        api: api.getAll,
    });
    return (React.createElement(PageLayout, { title: t('offerLists'), actions: React.createElement(Box, null,
            React.createElement(DownloadButton, { title: t('buttons.downloadOffersCsv'), size: "medium", path: "/api/offers/export.csv", downloadFilename: "offers.csv", withDownloadTimestamp: true }),
            React.createElement(Button, { onClick: function () { return navigate('/admin/offer_lists/upload'); }, "aria-label": "upload", sx: {
                    marginLeft: 1,
                } },
                React.createElement(UploadIcon, null),
                t('upload'))) },
        React.createElement(MaterialTable, { model: "offerList", sortSaveKey: "adminOfferLists", columns: columns, data: fetchOfferLists, options: {
                paging: true,
                filtering: true,
                sorting: false,
            }, editable: {
                isDeleteHidden: function (_a) {
                    var status = _a.status;
                    return status !== 'draft';
                },
                onRowDelete: handleDelete,
            }, detailPath: function (offerList) { return "/admin/offer_lists/".concat(offerList.id); } })));
};
export default AdminOfferListsPage;
